import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import  Home  from "./pages/Home";
import Planning from "./scenes/planning";
import TEst from "./scenes/test";
import OeeGrid from "./pages/OeeGrid";
import Tasks from "./scenes/Tasks";
import Machine from "./pages/Machine";
import Material from "./pages/Material";
import Instructions from "./pages/Instructions";
import Drawings from "./pages/Drawings";
import File from "./pages/File";
import ViewInstructions from './features/instructions/components/viewInstruction';
import MachineDetailsPage from "./pages/MachineDetailsPage";
import StopReasonCodesPage from "./pages/StopReasonCodesPage";
import StopReasonCodeGroupsPage from "./pages/StopReasonCodeGroupsPage";
import Activities from './pages/Activities';
import Gantt from "./pages/Gantt";
import SplitMachineStopPage from "./pages/SplitMachineStopPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import SettingsPage from "./pages/SettingsPage";
import EmbeddedReportsPage from "./pages/EmbeddedReportsPage";
import MachineDashboardPage from "./pages/MachineDashboardPage";
import ToolsPage from "./pages/Tools";
import ProductionItemsPage from "./pages/ProductionItemsPage";
import ClearLocalStoragePage from "./pages/ClearLocalStoragePage";
import MachineTypesPage from "./pages/MachineTypesPage";
import MachineSettingsPage from "./pages/MachineSettingsPage";
import MachinesStatusPage from "./pages/MachinesStatusPage";
import SensorDataDiagramSettingsPage from "./pages/SensorDataDiagramSettingsPage";
import MachineLabelsPage from "./pages/MachineLabelsPage";
import ProductionPlanPage from "./pages/ProductionPlanPage";
import AutocodeSchedulesPage from "./pages/AutocodeSchedulesPage";
import StopsPage from "./pages/StopsPage";
import UsersPage from "./pages/Users";
import { ProtectedRoute } from "./auth/authUi";
import { Navigate } from "react-router-dom";
import WeekSchedulePage from "./pages/WeekSchedulePage";
import WeekTemplatesPage from "./pages/WeekTemplatesPage";
import AssignWeekTemplateToMachinesPage from "./pages/AssignWeekTemplateToMachinesPage";
import CalendarPage from "./pages/CalendarPage";
import CmmsAssetHierarchyPage from "./pages/CmmsAssetHierarchyPage";
import CmmsWorkOrdersPage from "./pages/CmmsWorkOrdersPage";
import CmmsRecurringSchedulesPage from "./pages/CmmsRecurringSchedulesPage";
import CmmsSparePartsPage from "./pages/CmmsSparePartsPage";
import CmmsToolsPage from "./pages/CmmsToolsPage";
import CmmsSettingsPage from "./pages/CmmsSettingsPage";
import CmmsFeatureRoute from "./features/cmms/components/CmmsFeatureRoute";
import { CMMS_MANAGER_ROLES } from "./features/cmms/cmmsRoles";
import ActiveProductionOrdersPage from "./pages/ActiveProductionOrdersPage";

const AppRoutes = [
  {
    
    element: <Home />
  },
  {
    path: '/counter',
    element: <Counter />
  },
  {
    path: '/fetch-data',
    element: <FetchData />
  },
  {
    index: true,
    element:<Home />
  },
  {
    path:"/planning",
    element:<Planning />
  },
  {
    path:"/machines",
    element:<Machine />
  },
  {
    path:"/machines/:id",
    element:<MachineDetailsPage />
  },
  {
    path:"/machines/:id/",
    element:<MachineDetailsPage />
  },
  {
    path:"/test",
    element:<TEst />
  },
  {
    path:"/oeegrid",
    element: <OeeGrid />
  },
  {
    path:"/tasks",
    element: <Tasks />
  },
  {
    path:"/material",
    element: <Material />
  },
  {
    path:"/gantt",
    element: <Gantt />
  },
  {
    path:"/stopreasoncodes",
    element: <ProtectedRoute anyOf={[1,2]} element={<StopReasonCodesPage />} fallback={<Navigate to="/" />} />
  },
    {
    path:"/stopreasoncodegroups",
    element: <ProtectedRoute anyOf={[1,2]} element={<StopReasonCodeGroupsPage />} fallback={<Navigate to="/" />} />
  },
  {
    path:"/instructions",
    element: <Instructions />
  },
  {
    path:"/drawings",
    element: <Drawings />
  },
  {
    path:"/instructions/:id",
    element: <ViewInstructions />
  },
  {
    path:"/file",
    element: <File />
  },
  {
    path:"/machinestops/:id/split/",
    element:<SplitMachineStopPage />
  },
  {
    path:"/settings",
    element: <SettingsPage />
  },
  {
    path:"/embeddedreports",
    element: <ProtectedRoute anyOf={[1,2]} element={<EmbeddedReportsPage />} fallback={<Navigate to="/" />} />
  },
  {
    path:"/comingsoon",
    element: <ComingSoonPage />
  },
  {
    path:"/Activities",
    element: <Activities />
  },
  {
    path:"/machineDashboard/:id",
    element: <MachineDashboardPage />
  },
  {
    path:"/tools",
    element: <ProtectedRoute anyOf={[1,2]} element={<ToolsPage />} fallback={<Navigate to="/" />} />
  },
  {
    path:"/productionItems",
    element: <ProtectedRoute anyOf={[1,2]} element={<ProductionItemsPage />} fallback={<Navigate to="/" />} />
  },
  {
    path:"/clearLocalStorage",
    element: <ClearLocalStoragePage />
  },
  {
    path:"/machineTypes",
    element: <ProtectedRoute anyOf={[1,2]} element={<MachineTypesPage />} fallback={<Navigate to="/" />} />
  },
  {
    path:"/machinesStatus",
    element:<MachinesStatusPage />
  },
  {
    path:"/sensorDataDiagramSettings/:id",
    element: <ProtectedRoute anyOf={[1,2]} element={<SensorDataDiagramSettingsPage />} fallback={<Navigate to="/" />} />
    
  },
  {
    path:"/machineLabels",
    element: <ProtectedRoute anyOf={[1,2]} element={<MachineLabelsPage />} fallback={<Navigate to="/" />} />
  },
  {
    path:"/productionPlan",
    element: <ProductionPlanPage />
  },
  {
    path:"/autocodeSchedules",
    element: <ProtectedRoute anyOf={[1,2]} element={<AutocodeSchedulesPage />} fallback={<Navigate to="/" />} />
  },
  {
    path:"/stops",
    element: <StopsPage /> 
  },
  {
    path:"/users",
    element: <ProtectedRoute anyOf={[1,2]} element={<UsersPage />} fallback={<Navigate to="/" />} />
  },
  {
    path: '/weekschedule',
    element: <ProtectedRoute anyOf={[1,2]} element={<WeekSchedulePage />} fallback={<Navigate to="/" />} />
  },
  {
    path: '/weektemplates',
    element: <ProtectedRoute anyOf={[1,2]} element={<WeekTemplatesPage />} fallback={<Navigate to="/" />} />
  },
  {
    path: '/assignweektemplatetomachines',
    element: <ProtectedRoute anyOf={[1,2]} element={<AssignWeekTemplateToMachinesPage />} fallback={<Navigate to="/" />} />
  },
  {
    path: '/calendar',
    element: <ProtectedRoute anyOf={[1,2]} element={<CalendarPage />} fallback={<Navigate to="/" />} />
  },
  {
    path:"/activeProductionOrders",
    element: <ProtectedRoute anyOf={[1,2]} element={<ActiveProductionOrdersPage />} fallback={<Navigate to="/" />} />
  },
  // CMMS routes carry a feature gate on top of the role guard — hiding the menu does not
  // stop a bookmark or a pasted URL from reaching an unreleased module.
  // Role 4 (Technician) must stay in these lists, or a technician-only user is redirected
  // away from the very pages the role exists to use.
  {
    path: '/cmms/asset-hierarchy',
    element: <CmmsFeatureRoute element={<ProtectedRoute anyOf={[1,2,3,4]} element={<CmmsAssetHierarchyPage />} fallback={<Navigate to="/" />} />} />
  },
  {
    path: '/cmms/work-orders',
    element: <CmmsFeatureRoute element={<ProtectedRoute anyOf={[1,2,3,4]} element={<CmmsWorkOrdersPage />} fallback={<Navigate to="/" />} />} />
  },
  {
    path: '/cmms/recurring-schedules',
    element: <CmmsFeatureRoute element={<ProtectedRoute anyOf={[1,2,3,4]} element={<CmmsRecurringSchedulesPage />} fallback={<Navigate to="/" />} />} />
  },
  // Reading the register is Cmms_Field, which every role in this list satisfies — a technician
  // has to be able to look a part up to book it onto a job. Writing is Cmms_Manager and is
  // gated on the buttons, not here: a page that 403s on every action is worse than one that
  // shows what it holds.
  {
    path: '/cmms/spare-parts',
    element: <CmmsFeatureRoute element={<ProtectedRoute anyOf={[1,2,3,4]} element={<CmmsSparePartsPage />} fallback={<Navigate to="/" />} />} />
  },
  // The tool register, read-only. Both endpoints behind it — /api/tool-monitoring/status and the
  // service log — are Cmms_Field, which is this list. Role 4 matters more here than anywhere else
  // on it: /tools is [1,2], so the technician who performs the service has never had a page that
  // shows what is due. Creating and editing a tool stays on /tools, which is Role_Superuser.
  {
    path: '/cmms/tools',
    element: <CmmsFeatureRoute element={<ProtectedRoute anyOf={[1,2,3,4]} element={<CmmsToolsPage />} fallback={<Navigate to="/" />} />} />
  },
  // this one is settings, and every endpoint behind it is Cmms_Manager, so
  // any other role would reach a page with nothing it can set.
  {
    path: '/cmms/settings',
    element: <CmmsFeatureRoute element={<ProtectedRoute anyOf={CMMS_MANAGER_ROLES} element={<CmmsSettingsPage />} fallback={<Navigate to="/" />} />} />
  }
];

export default AppRoutes;

export const apiRoutes = {
  getGanttData: 'api/gantt/getGanttData/:companyKey',
  getGanttDataMachine: 'api/gantt/getGanttDataMachine/:machineId'
};